import './index.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { toggleIntro } from '../../app/reducer';
import enhanceWithClickOutside from 'react-click-outside';
import { Translate } from 'react-redux-i18n';
import StockImg from '../../../assets/images/tutorial/tut-1.png';
import { I18n } from 'react-redux-i18n';

class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
    };
  }

  handleSkip = () => {
    const { toggleIntro } = this.props;
    toggleIntro(false);
  };

  handleClickOutside = () => {
    const { toggleIntro } = this.props;
    toggleIntro(false);
  };

  render() {
    const {
      handleStartIntro,
      userInfo: {
        profile: { name = 'user_name' },
      },
    } = this.props;

    return (
      <div className="intro-modal">
        <div className="title">
          <div className="text d-flex align-items-center">
            <a href="#" className="d-flex">
              <i className="icon-play-button text-stock-chart fs-20 mr-8" />
            </a>
            <Translate value={'common.TITLE_POPUP_TUTORIAL'} />
          </div>
          <div className="close-button">
            <a onClick={this.handleSkip} href="#">
              <i className="icon-close text-stock-chart" />
            </a>
          </div>
        </div>
        <div className="modal-container">
          <div className="welcome-text">
            {I18n.t('tutorial.tutorialContent.tut1.message', { user: name })}
          </div>
          <div className="stock-img" style={{ height: 204, width: 360 }}>
            <img src={StockImg} alt="tutorial-img" />
          </div>
          <div className="tutorial-group-button">
            <div className="d-flex button-container">
              <div className="tutorial-button start" onClick={handleStartIntro}>
                Start
              </div>
              <div className="tutorial-button skip" onClick={this.handleSkip}>
                Skip
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  toggleIntro,
};

const mapStateToProps = state => {
  return {
    userInfo: state.userInfo,
    // get user setting
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  enhanceWithClickOutside,
)(Modal);
